import React, { useEffect, useState } from 'react'
import { Report } from 'notiflix/build/notiflix-report-aio'
import { FieldGroup, FormCard, SubmitButtonMail } from '../../reusable'
import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { Checkbox } from '../../reusable/checkbox'
import { SignaturePad } from '../../reusable/sigPad'
import { sectionValidation } from '../../../helpers'
import { browserName, osName } from 'react-device-detect'
import { useClaimData } from '../../../claimProvider'
import { useSearchParams } from 'react-router-dom'

export const SignatureSentinel = (props: FormPartInterface) => {
    const { saveValueFunct, isActive, assignGroup, validateSection } = props
    const [currentStep, setCurrentStep] = useState(0)
    const [postCurrentStep, setPostCurrentStep] = useState(0)
    const [stepData, setStepData] = useState<any>({})
    const [termsAccepted, setTermsAccepted] = useState(false)
    const [hasSignature, setHasSignature] = useState(false)
    const claim = useClaimData()

    const [searchParams] = useSearchParams()
    const chase_id = searchParams.get('chase_id')
    const agent = searchParams.get('agent')

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)
        let tempStepData = { ...stepData }
        tempStepData[dataToSave.field] = dataToSave.value
        setStepData(tempStepData)
        console.log('Updated stepData:', tempStepData)

        if (dataToSave.field === 'acceptTerms') {
            setTermsAccepted(dataToSave.value === 'yes')
        }

        return saved
    }

    const handleBack = () => {
        assignGroup('review')
    }

    // const redirectToOpenBanking = () => {
    //     console.log('claim.openBankingLink: ', claim)
    //     window.location.href = claim.openBankingLink
    // }

    // console.log(stepData)
    const animateBeforeAssign = (assignment: string) => {
        console.log(stepData)

        setTimeout(() => {
            assignGroup(assignment)
        }, 400)
    }

    const getCurrentStep = () => {
        // console.log('is active: ', isActive == 'signature')
        // console.log('true: ', isActive == 'signature' && claim?.sigData?.token.length > 0)
        // console.log('claim: ', claim)

        return isActive == 'signature' && claim?.sigData ? (
            <FieldGroup title="Sign Your CFA & LOA">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep}>
                    <SignaturePad
                        extraPayload={{
                            browser: browserName,
                            device: osName,
                            type: claim.leadOrigin,
                            chase_id,
                            agent,
                            claim,
                        }}
                        additionalAction={() => animateBeforeAssign('openBanking')}
                        disclaimer="*By signing this document, you agree that Sentinel Legal can carry out a soft credit check through Valid8, Bosh Fintech or Checkboard to look at your car finance deals, check who you are, and stop money laundering. This check won't affect your credit score, and we will only look at information about your car finance. Once we have identified the car finance you have taken out from the soft credit check and/or our investigations, you agree that Sentinel Legal can use your signature to complete individual Letters of Authority relating to each finance provider and to pursue claims against each car finance provider under the terms you have agreed to by completing these documents. Your signature will only be used for claims linked to you, and you can ask us to stop using it at any time."
                        stepData={stepData}
                    >
                        <div style={{ marginBottom: '1rem' }}>
                            <Checkbox
                                fieldName={'acceptTerms'}
                                label={
                                    'I confirm that I have read, understood and agree to the Conditional Fee Agreement and Letter of Authority documents above. I authorize Sentinel Legal to act on my behalf and to apply my signature to these documents for the purpose of submitting my claim.'
                                }
                                saveValue={preSaveValueFunct}
                            />
                        </div>

                        <div style={{ marginBottom: '1rem' }}>
                            <Checkbox
                                fieldName={'privacyPolicyConsent'}
                                label={
                                    "I agree to the privacy policy of Sentinel Legal and authorise them to conduct soft credit searches on my behalf through their provider, Valid8 IP Ltd, with no impact on my credit score. I also agree to Valid8 IP's privacy policy."
                                }
                                saveValue={preSaveValueFunct}
                            />
                        </div>
                    </SignaturePad>
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
